import { createSlice } from '@reduxjs/toolkit';

import { fetchPeakTimes } from './thunks';
import { PeakTime } from '../../types';

interface InitialState {
  loading: boolean;
  error: any;
  data: PeakTime[];
}

const initialState: InitialState = {
  loading: false,
  error: null,
  data: [],
};

const slice = createSlice({
  name: 'store',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPeakTimes.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPeakTimes.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload;
    });
    builder.addCase(fetchPeakTimes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error; // todo check it
    });
  },
});

export default slice.reducer;
